package com.routexk.quiz.ui.sections.footer

import androidx.compose.runtime.Composable
import com.routexk.quiz.ui.sections.footer.components.HorizontalDivider
import com.routexk.quiz.ui.sections.footer.components.FooterLink
import com.routexk.quiz.ui.sections.footer.components.SocialIcon
import com.routexk.quiz.ui.sections.footer.components.VerticalDivider
import com.routexk.quiz.ui.theme.AppColors
import com.routexk.quiz.ui.utils.Constants
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*

@Composable
internal fun FooterDesktop() {
    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    Column(
        Modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.Start
    ) {

        Row(
            Modifier
                .fillMaxWidth()
                .padding(bottom = 2.cssRem),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.Top
        ) {

            Column(
                Modifier.gap(0.5.cssRem)
            ) {
                SpanText(
                    "CONTACT:",
                    Modifier
                        .fontSize(0.75.cssRem)
                        .fontWeight(FontWeight.Bold)
                        .color(colors.textPrimary)
                        .letterSpacing(0.1.em)
                )
                SpanText(
                    Constants.PHONE,
                    Modifier
                        .fontSize(0.9.cssRem)
                        .color(colors.textSecondary)
                )
                SpanText(
                    Constants.CONTACT_NAME,
                    Modifier
                        .fontSize(0.9.cssRem)
                        .color(colors.textSecondary)
                )
            }

            VerticalDivider()

            Column(
                Modifier.gap(0.5.cssRem)
            ) {
                SpanText(
                    "NAVIGATION",
                    Modifier
                        .fontSize(0.75.cssRem)
                        .fontWeight(FontWeight.Bold)
                        .color(colors.textPrimary)
                        .letterSpacing(0.1.em)
                        .margin(bottom = 0.3.cssRem)
                )
                FooterLink("About", Constants.SECTION_ABOUT)
                FooterLink("Services", Constants.SECTION_SERVICES)
                FooterLink("Projects", Constants.SECTION_PROJECTS)
                FooterLink("Contact", Constants.SECTION_CONTACTS)
            }

            VerticalDivider()

            Column(
                Modifier.gap(0.3.cssRem)
            ) {
                SpanText(
                    "Crafting digital",
                    Modifier
                        .fontSize(0.9.cssRem)
                        .color(colors.textSecondary)
                )
                SpanText(
                    "experiences that inspire",
                    Modifier
                        .fontSize(0.9.cssRem)
                        .color(colors.textSecondary)
                )
                SpanText(
                    "and convert.",
                    Modifier
                        .fontSize(0.9.cssRem)
                        .color(colors.textSecondary)
                )
            }

            VerticalDivider()

            Column(
                Modifier.gap(1.cssRem),
                horizontalAlignment = Alignment.End
            ) {

                Row(
                    Modifier.gap(0.75.cssRem)
                ) {
                    SocialIcon("📷", Constants.INSTAGRAM_URL, "Instagram")
                    SocialIcon("👥", Constants.FACEBOOK_URL, "Facebook")
                    SocialIcon("🐦", Constants.TWITTER_URL, "Twitter")
                    SocialIcon("💼", Constants.LINKEDIN_URL, "LinkedIn")
                }

                Column(
                    horizontalAlignment = Alignment.End
                ) {
                    SpanText(
                        Constants.COPYRIGHT,
                        Modifier
                            .fontSize(0.8.cssRem)
                            .color(colors.textTertiary)
                    )
                    SpanText(
                        "All rights reserved.",
                        Modifier
                            .fontSize(0.8.cssRem)
                            .color(colors.textTertiary)
                    )
                }
            }
        }

        HorizontalDivider()

        FooterLink("Privacy Policy", "#privacy")
    }
}
